/**
 * Progressão: XP e nível. Curva RequiredXP = 100 × Level^1.35.
 * Ao subir de nível aplica +5 Max HP e +1 Base Damage no player (via GameConfig).
 */
import { GameConfig } from "../config/GameConfig";
import { events } from "../core/Events";
import { Vip } from "./Vip";

export class XPSystem {
  level: number = GameConfig.progression.startLevel;
  xp = 0;
  xpForNext: number = GameConfig.progression.xpForLevel(GameConfig.progression.startLevel);
  /** 10.6T — booster de XP comprado na Loja de Diamantes (Game.ts atualiza). */
  boostMult = 1;

  private readonly unsub: () => void;

  constructor() {
    this.unsub = events.on("enemy:killed", (p) => this.gain(p.xpReward));
  }

  /** Ganha XP. Os bônus de nível são aplicados pelo Game via recálculo (evento level:up). */
  gain(amount: number): void {
    // 10.9AW — TETO do bônus acumulado (tier VIP × Passe × booster chegava a 4.5×): não atrapalha a curva
    const mult = Math.min(GameConfig.progression.xpMultCap, Vip.xpMult * this.boostMult);
    const applied = Math.round(amount * mult);
    this.xp += applied;
    // 10.9J6 — emitia o valor BRUTO (antes do multiplicador de VIP/booster); hoje nada escuta este
    // evento, mas qualquer estatística/missão futura que somasse isto ficaria abaixo do XP real.
    events.emit("xp:gained", { amount: applied });
    while (this.xp >= this.xpForNext) {
      this.xp -= this.xpForNext;
      this.level += 1;
      this.xpForNext = GameConfig.progression.xpForLevel(this.level);
      events.emit("level:up", { level: this.level });
    }
  }

  /** Fração de progresso até o próximo nível (0..1). */
  get fraction(): number {
    return this.xpForNext > 0 ? this.xp / this.xpForNext : 0;
  }

  getState(): { level: number; xp: number } {
    return { level: this.level, xp: this.xp };
  }

  /** Define nível/XP sem aplicar bônus (o carregamento reaplica os bônus à parte). */
  setState(level: number, xp: number): void {
    this.level = level;
    this.xp = xp;
    this.xpForNext = GameConfig.progression.xpForLevel(level);
  }

  reset(): void {
    this.level = GameConfig.progression.startLevel;
    this.xp = 0;
    this.xpForNext = GameConfig.progression.xpForLevel(this.level);
  }

  dispose(): void {
    this.unsub();
  }
}
